<app-dialog
    [visible]="true"
    [closable]="true"
    [cssStyle]="{ 'left.rem': -20, 'top.rem': -23 }"
    cssClass="dialog-sm-relative"
>
    <div id="user-profile">
        <div class="header">
            <div id="user" class="row">
                <img src="{{ user.profileImage }}" />
                <div class="col">
                    <h3>{{ user.firstName }} {{ user.lastName }}</h3>
                    <span class="body-2">
                        <app-icon symbol="Email"></app-icon>
                        {{ user.email }}
                    </span>
                </div>
            </div>
        </div>
        <div class="profile-body">
            <ul>
                <li>
                    <app-icon-link symbol="Legal" (click)="openLegal()" label="Legal"></app-icon-link>
                </li>
                <li>
                    <app-icon-link symbol="Logout" (click)="signOut()" label="Logout"></app-icon-link>
                </li>
            </ul>
        </div>
    </div>
</app-dialog>
